import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Order, OrderIndexParams } from '@rd/types/order.type';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import * as actions from '../../store/actions/order.actions';
import { getOrderFeatureState, getOrdersMap } from '../../store/reducers';
import { OrderState } from '../../store/reducers/order.reducer';

// Not going to implement methods for creating orders and items to cart for now
@Injectable({ providedIn: 'root' })
export class OrderFacade {
  constructor(private store: Store) {}

  order$: Observable<Order | undefined> = this.store
    .select(getOrderFeatureState)
    .pipe(
      map((state) => state.ordersMap.orders[state.ordersMap.selected]),
      distinctUntilChanged(),
    );

  orders$: Observable<Order[]> = this.store.select(getOrderFeatureState).pipe(
    map((state) => state.ordersList.orders),
    distinctUntilChanged(),
  );

  ordersMap$: Observable<Record<string, Order>> =
    this.store.select(getOrdersMap);

  getOrdersLoading$: Observable<boolean> = this.store
    .select(getOrderFeatureState)
    .pipe(
      map((state: OrderState) => state.ordersList.loading),
      distinctUntilChanged(),
    );

  getOrdersError$: Observable<boolean> = this.store
    .select(getOrderFeatureState)
    .pipe(
      map((state: OrderState) => state.ordersList.error),
      distinctUntilChanged(),
    );

  getOrderLoading$: Observable<boolean> = this.store
    .select(getOrderFeatureState)
    .pipe(
      map((state) => state.ordersMap.loading),
      distinctUntilChanged(),
    );

  getOrderError$: Observable<boolean> = this.store
    .select(getOrderFeatureState)
    .pipe(
      map((state) => state.ordersMap.error),
      distinctUntilChanged(),
    );

  // Actions

  getOrders(orderIndexParams: Partial<OrderIndexParams>): void {
    this.store.dispatch(new actions.GetOrders(orderIndexParams));
  }

  getOrder(id: string): void {
    this.store.dispatch(new actions.GetOrder(id));
  }

  selectOrder(id: string): void {
    this.store.dispatch(new actions.SelectOrder(id));
  }

  unselectOrder(): void {
    this.store.dispatch(new actions.UnselectOrder());
  }

  resetOrderMap(): void {
    this.store.dispatch(new actions.ResetOrderMap());
  }
}
